export const representationPreviewEnabled = import.meta.env.MODE === "development";

const COMPLETED_USER_KEY = "simon.representation-preview-completed-user";

export function completeRepresentationPreview(userId: string): void {
  window.sessionStorage.setItem(COMPLETED_USER_KEY, userId);
}

export function hasCompletedRepresentationPreview(userId: string): boolean {
  return window.sessionStorage.getItem(COMPLETED_USER_KEY) === userId;
}

export function resetRepresentationPreview(): void {
  window.sessionStorage.removeItem(COMPLETED_USER_KEY);
}
